module.exports = __webpack_public_path__ + "static/media/zhariff.0ae2ae99.png";